import { ptBR } from 'date-fns/locale/pt-BR'
import {
  format,
  formatDistanceStrict,
  parseISO,
  isValid,
  addHours
} from 'date-fns'

const options = { locale: ptBR }

export const getDateDistanceToNow = (fromDate: string): string => {
  if (!fromDate) {
    return ''
  }

  let result = `há ${formatDistanceStrict(
    parseISO(fromDate),
    new Date(),
    options
  )}`
  if (result.includes('horas')) result = 'hoje'

  return result
}

export const getDateInLongText = (date: string): string => {
  const newDate = new Date(date)

  if (isValid(newDate)) {
    return format(newDate, "dd' de 'MMMM' de 'yyyy", options)
  }

  return ''
}

export const formatDate = (
  value: string | Date,
  formatString: string
): string => {
  if (!value) {
    return ''
  }

  try {
    const date =
      typeof value === 'string' ? addHours(new Date(value), 3) : value
    return format(date, formatString, { locale: ptBR })
  } catch (err) {
    console.log(err)
  }

  return '-'
}
